import React from "react";
import ReactGA from "react-ga";

import "./base.css";
import styles from "./App.css";

import CheckFeatures from "./components/CheckFeatures/CheckFeatures";

import CrosswordContainer from "./components/Crossword/CrosswordContainer";
import SettingsContainer from "./components/Settings/SettingsContainer";
import SolvedContainer from "./components/Solved/SolvedContainer";
import PaywallContainer from "./components/Paywall/PaywallContainer";
import LoginContainer from "./components/Login/LoginContainer";
import SecretContainer from "./components/Secret/SecretContainer";
import LevelsContainer from "./components/Levels/LevelsContainer";
import LanguagesContainer from "./components/Languages/LanguagesContainer";
import PlayersContainer from "./components/Players/PlayersContainer";
import PrizesContainer from "./components/Prizes/PrizesContainer";
import AboutContainer from "./components/About/AboutContainer";
import DragLayer from "./components/DragLayer/DragLayer";

// Init google analytics
ReactGA.initialize("UA-112456032-1");

const App = () => (
  <CheckFeatures required={["svg", "svgforeignobject", "localstorage"]}>
    <div className={styles.app}>
      <CrosswordContainer />
      <div className={styles.overlays}>
        <LevelsContainer />
        <SettingsContainer />
        <SolvedContainer />
        <LoginContainer />
        <PaywallContainer />
        <SecretContainer />
        <LanguagesContainer />
        <PlayersContainer />
        <PrizesContainer />
        <AboutContainer />
      </div>
      <DragLayer />
    </div>
  </CheckFeatures>
);

export default App;



// WEBPACK FOOTER //
// ./src/App.js